module.exports = __webpack_public_path__ + "img/vuetify_logo.c7ad3d2c.png";